import React/*, { Component }*/, {useState} from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import SelectionPage from "./SelectionPage";
import PracticePage from "./PracticePage";
import GradualDivisionExerciseGenerator from "../exercises/exerciseGenerator/GradualDivisionExerciseGenerator";
import GradualMultiplicationExerciseGenerator from "../exercises/exerciseGenerator/GradualMultiplicationExerciseGenerator";
import WelcomePage from "./WelcomePage";

const LOCALSTORAGE_DISCLAIMER_ACCEPTED = "disclaimer_accepted";


export default function MainPage(){
    const [modes, setModes] = useState([])
    new GradualDivisionExerciseGenerator().generate()
    new GradualMultiplicationExerciseGenerator().generate()
    const onModesSelected = (modes) =>{
        setModes(modes)
    };

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route
                    exact path={"/info"}
                    element={<WelcomePage />}
                />
                <Route
                    exact path={"/"}
                    element={<SelectionPage onModesSelected={onModesSelected} />}
                />
                <Route
                    exact path={"/practice"}
                    element={<PracticePage modes={modes} />}
                />
            </Routes>
        </BrowserRouter>
    );
}

export {LOCALSTORAGE_DISCLAIMER_ACCEPTED}
